import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ApiObjectService {

  constructor(public rest: RestService) { }

  public updateObject(webpage_id, apiObject) {
    apiObject.webpageId = apiObject.webpageId.$oid ? apiObject.webpageId.$oid : apiObject.webpageId;
    // if(webobject.xpaths && webobject.xpaths.length > 0) {
    //   webobject.xpaths.forEach((xpath, index) => {
    //     if (xpath && xpath.trim() !== "") {
    //       // Update the XPath by replacing \" with single quotes
    //       webobject.xpaths[index] = xpath.replace(/\"/g, "'");
    //     }
    //   });
    // }
    // if (webobject.css && webobject.css.trim() !== "") {
    //   webobject.css = webobject.css.replace(/\"/g, "'");
    // }
    if (apiObject.selectedWebPageId && apiObject.selectedWebPageId.$oid) {
      apiObject.selectedWebPageId = apiObject.selectedWebPageId.$oid;
    }
    var data = {
      webPage:  { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      apiObject: apiObject
    };
    return this.rest.put('updateapiobject', data);
  }

  public updateObjectDb2(webpage_id, apiObject) {
    apiObject.webpageId = apiObject.webpageId.$oid ? apiObject.webpageId.$oid : apiObject.webpageId;
    if (apiObject.selectedWebPageId && apiObject.selectedWebPageId.$oid) {
      apiObject.selectedWebPageId = apiObject.selectedWebPageId.$oid;
    }
    var data = {
      webPage:  { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      apiObject: apiObject
    };
    return this.rest.put('updateapiobjectdb2', data);
  }

  public addApiObject(webpage_id, apiObject) {
    apiObject.webpageId = apiObject.webpageId.$oid ? apiObject.webpageId.$oid : apiObject.webpageId;
    if (apiObject.selectedWebPageId && apiObject.selectedWebPageId.$oid) {
      apiObject.selectedWebPageId = apiObject.selectedWebPageId.$oid;
    }
    var data = {
      webPage:  { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      apiObject: apiObject
    };
    return this.rest.post('addapiobject', data);
  }

  public deleteObject(apiobject_id) {
    return this.rest.put('deleteapiobject', null, apiobject_id);
  }

  public updateValidationTemplate(apiObjectId: string, template: string) {
    return this.rest.put('updateapiobjectvalidationtemplate', { value: template }, apiObjectId);
  }

}
